import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import Loader from "../../common/Loader";
import { DateTime } from "luxon";
import CatalogModal from "../../common/CatalogModal";
import QuotationFinalValues from "./QuotationFinalValues";
import GenerateContractModal from "./GenerateContractModal";
import OverlayContent from "../../common/OverlayContent";
import QuotationPdf from "./QuotationPdf";
import QuotationRecapPdf from "./QuotationRecapPdf";
import useQuotationDetail from "./hooks/useQuotationDetail";
import ViewContractsModal from "./QuotationSearch/ViewContractsModal";
import QuotationHeaderBar from "./QuotationHeaderBar";
import QuotationParameters from "./QuotationParameters";
import QuotationActionBar from "./QuotationActionBar";
import FinanceModalV2 from "../FinanceV2/components/FinanceModalV2";
import DossierDashboard from "./DossierDashboard/DossierDashboard";
import useDemandesParDevis from "./hooks/useDemandesParDevis";

const QuotationDetail = (props) => {
  const {
    state,
    selectedClient,
    setSelectedClient,
    selectedUser,
    setSelectedUser,
    selectedVehicle,
    setSelectedVehicle,
    dur,
    setDur,
    km,
    setKm,
    quotationOpened,
    setQuotationOpened,
    overlayOpened,
    sort,
    setSort,
    filters,
    setFilters,
    hideKeys,
    pdfOpen,
    setPdfOpen,
    recapOpen,
    setRecapOpen,
    quotationSelected,
    setQuotationSelected,
    tableWidth,
    setTableWidth,
    openClientQuotationModal,
    clientQuotations,
    quotationData,
    constantData,
    clientData,
    tireData,
    quotationDetailActions,
    isParametersOpen,
    setIsParametersOpen,
  } = useQuotationDetail(props);

  const [financeModal, setFinanceModal] = useState(null);

  const { demandesParRef, refresh: refreshDemandesParDevis } =
    useDemandesParDevis(selectedClient?.uuid);

  const scrollToQuotation = (index) => {
    const el = document.getElementById("trrl" + index);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  // LS-747 : démonter les modales contrat à leur fermeture, pour que la
  // prochaine ouverture reparte de l'état courant de la ligne de devis.
  const resetQuotationOpened = React.useCallback(
    () => setQuotationOpened({ q: null, i: null }),
    [setQuotationOpened],
  );

  return (
    <div
      className="container-fluid"
      style={{ paddingBottom: 100, marginBottom: 800 }}
    >
      <div className="row">
        <div className="col-12">
          <QuotationHeaderBar
            quotationData={quotationData}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            clientError={state.error.client}
            clientQuotations={clientQuotations}
            openClientQuotationModal={openClientQuotationModal}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            userError={state.error.assignedTo}
            isParametersOpen={isParametersOpen}
            setIsParametersOpen={setIsParametersOpen}
            tableWidth={tableWidth}
            setTableWidth={setTableWidth}
          />

          <div className="row">
            <QuotationParameters
              isParametersOpen={isParametersOpen}
              sort={sort}
              setSort={setSort}
              filters={filters}
              setFilters={setFilters}
              constantData={constantData}
            />
            <div className="col-12">
              <div className="" style={{ overflowX: "scroll" }}>
                <div className="accordion" id="quotation-accordion">
                  <table
                    className="table bg-transparent"
                    id="quotable"
                    style={{ width: tableWidth + "%" }}
                  >
                    <tbody>
                      {quotationData.quotations.length > 0 ? (
                        quotationData.quotations.map((rl, k) => (
                          <QuotationFinalValues
                            key={"qfv" + k}
                            index={k}
                            quotation={rl}
                            dossierUuid={quotationData.uuid}
                            clientUuid={selectedClient?.uuid}
                            onOpenFinanceModal={(devisUuid) =>
                              setFinanceModal({
                                devisUuid,
                                clientUuid: selectedClient?.uuid,
                                reference: quotationData.reference,
                              })
                            }
                            financeStatus={
                              // LS-678 — rattachement par uuid de devis ; la
                              // référence (libellé véhicule, non unique) ne
                              // sert que de repli tant que l'API ne renvoie
                              // pas devis_uuids.
                              demandesParRef.get(rl.uuid) ||
                              demandesParRef.get(rl.reference) ||
                              null
                            }
                            setQuotationStatus={
                              quotationDetailActions.setQuotationStatus
                            }
                            rlVehicleChange={(e) =>
                              quotationDetailActions.rlVehicleChange(e, k)
                            }
                            deleteQuotation={() =>
                              quotationDetailActions.deleteQuotation(k)
                            }
                            rlChange={(e) =>
                              quotationDetailActions.rlChange(e, k)
                            }
                            applyMarginFromFinanceRent={(marginTTC) =>
                              quotationDetailActions.applyMarginFromFinanceRent(
                                marginTTC,
                                k,
                              )
                            }
                            setQuotationOpened={() =>
                              setQuotationOpened({ q: rl, i: k })
                            }
                            toggleOverlay={quotationDetailActions.toggleOverlay}
                            overlayOpened={overlayOpened}
                            navQuotation={quotationDetailActions.navQuotation}
                            totalQuotation={quotationData.quotations.length}
                            hideKeys={hideKeys}
                            tireData={tireData}
                            openPdf={() => quotationDetailActions.openPdf(rl)}
                            setQuotationSelected={setQuotationSelected}
                            isCreate={props.match.params.id == "create"}
                            duplicateQuotation={
                              quotationDetailActions.duplicateQuotation
                            }
                            changeLineOrder={
                              quotationDetailActions.changeLineOrder
                            }
                            tableWidth={tableWidth}
                          />
                        ))
                      ) : state.quotation.isLoading ? (
                        <tr className="text-center col-12">
                          <td colSpan="13">
                            <Loader />
                          </td>
                        </tr>
                      ) : (
                        <p className="text-muted">
                          Aucune loi de roulage n'a encore été ajoutée
                        </p>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              className="no-print"
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                zIndex: 99,
                display: "flex",
                justifyContent: "center",
                pointerEvents: "none",
              }}
            >
              <div
                style={{
                  maxWidth: 1320,
                  pointerEvents: "auto",
                }}
              >
                <QuotationActionBar
                  dur={dur}
                  setDur={setDur}
                  km={km}
                  setKm={setKm}
                  selectedVehicle={selectedVehicle}
                  quotationDetailActions={quotationDetailActions}
                  quotationSelected={quotationSelected}
                  quotationData={quotationData}
                  state={state}
                  props={props}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DossierDashboard
        quotations={quotationData.quotations}
        constantData={constantData}
        filters={filters}
        setFilters={setFilters}
        onScrollToQuotation={scrollToQuotation}
      />
      {quotationOpened.q && (
        <>
          <GenerateContractModal
            quotation={{ ...quotationOpened.q, client: selectedClient }}
            setQuotationStatus={quotationDetailActions.setQuotationStatus}
            index={quotationOpened.i}
            vehicleQuantity={quotationOpened.q.quantity}
            onClosed={resetQuotationOpened}
          />
          <ViewContractsModal
            quotation={quotationOpened.q}
            onClosed={resetQuotationOpened}
          />
        </>
      )}
      <CatalogModal
        selectedVehicle={selectedVehicle}
        selectVehicle={setSelectedVehicle}
      />
      {pdfOpen && (
        <OverlayContent close={() => setPdfOpen(false)}>
          <QuotationPdf
            quotation={pdfOpen}
            dossierUuid={props.match.params.uuid}
            client={clientData.find(
              (c) =>
                quotationData.client == c.uuid ||
                quotationData.client.uuid == c.uuid,
            )}
            date={quotationData.updatedAt}
            onSignatureChange={(champs) =>
              quotationDetailActions.majStatutSignature(pdfOpen.uuid, champs)
            }
          />
        </OverlayContent>
      )}
      {recapOpen && (
        <OverlayContent close={() => setRecapOpen(false)}>
          <QuotationRecapPdf
            quotations={recapOpen}
            client={clientData.find(
              (c) =>
                quotationData.client == c.uuid ||
                quotationData.client.uuid == c.uuid,
            )}
            date={DateTime.local().toFormat("dd/MM/yyyy")}
            constantData={constantData}
          />
        </OverlayContent>
      )}
      {financeModal && (
        <FinanceModalV2
          devisUuid={financeModal.devisUuid}
          clientUuid={financeModal.clientUuid}
          reference={financeModal.reference}
          onClose={() => {
            setFinanceModal(null);
            refreshDemandesParDevis();
          }}
        />
      )}
    </div>
  );
};

export default withRouter(QuotationDetail);
